/**
 * A label that opens a hidden file input - the map's "Import…" buttons.
 *
 * The input is CLEARED before the file is handed on: picking the SAME
 * file twice must fire again, which it will not while the input still
 * holds it. `inputLabel` and `inputTestId` name the input itself.
 */
export default function BattlefieldFileButton({
  className,
  testId,
  accept,
  inputLabel,
  inputTestId,
  onFile,
  children,
}) {
  return (
    <label className={className} data-testid={testId}>
      {children}
      <input
        type="file"
        accept={accept}
        aria-label={inputLabel}
        data-testid={inputTestId}
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          e.target.value = '';
          if (file) onFile?.(file);
        }}
      />
    </label>
  );
}
